import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { MdOutlineMarkAsUnread } from "react-icons/md";
import { WiDirectionRight } from "react-icons/wi";
import { useTranslation } from "react-i18next";


export default function Couriel() {
    const { t } = useTranslation("footer");
    const [isActive, setIsActive] = useState(false);
    const courielRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (courielRef.current) {
                const rect = courielRef.current.getBoundingClientRect();
                // Check if the element is in the viewport (adjust the threshold as needed)
                if (rect.top < window.innerHeight && rect.bottom > 0) {
                    setIsActive(true);
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); // Check on initial load
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div
            ref={courielRef}
            className={`couriel couriel-transition ${isActive ? "active" : ""}`}
        >
            <MdOutlineMarkAsUnread className="iconcouriel" />
            <p className="textcouriel">{t("footer.couriel.descritption")}</p>
            <Link to="/Creer_compte" className="lienfooter">
                {t("footer.couriel.button")}
                <WiDirectionRight className="iconesens" />
            </Link>
        </div>
    );
}
